import { render } from "./MyReportsDataTable.vue?vue&type=template&id=47074f48"
import script from "./MyReportsDataTable.vue?vue&type=script&lang=js"
export * from "./MyReportsDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__